import classNames from 'classnames';
import type { ChangeEvent, ReactNode } from 'react';
import styled from 'styled-components';

import { FormControlLabel } from 'atoms/inputs/FormControlLabel';
import { Switch as AtomSwitch } from 'atoms/inputs/Switch';

type Props = {
  checked: boolean;
  label?: string | ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
};

const Label = styled.span`
  font-size: 15px;
  line-height: 22px;
  font-weight: 400;
  font-style: normal;
  color: var(--c-white);
  &.checked:not(.Mui-disabled) {
    color: var(--c-white);
  }
  &.Mui-disabled {
    color: var(--c-nd-600);
  }
`;
const Control = styled(FormControlLabel)`
  width: 100%;
  justify-content: space-between;
`;

export const Switch = ({ checked, disabled, onChange, label }: Props) => {
  return (
    <Control
      className={classNames('FilterWidget', { visible: !disabled })}
      labelPlacement="start"
      control={
        <AtomSwitch checked={checked} disabled={disabled} onChange={onChange} />
      }
      label={<Label className={classNames({ checked })}>{label}</Label>}
    />
  );
};
